import { render } from "./ParutionPage.vue?vue&type=template&id=784882ec"
import script from "./ParutionPage.vue?vue&type=script&lang=js"
export * from "./ParutionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__